import {
  GET_SUB_STATS,
  GET_SEARCH_RESULTS,
  GET_ALL_SEARCH_RESULTS
} from '../actions/SubscriptionInfo';
import {
  success
} from "./helpers";

const initialState = {
  subscription_total: [],
  search_results: [],
  all_search_results: []
}

export const subscriptionInfo = (state = initialState, action) => {
  switch (action.type) {
    case success(GET_SUB_STATS):
      let arr = action.payload.map((item) => Object.assign({}, {
        label: item.key,
        value: item.value
      }))
      return {
        ...state,
        subscription_total: arr
      }
    case success(GET_SEARCH_RESULTS):
      let filterPayload = {
        ...action.payload
      }
      for (const list of filterPayload.clients.data) {
        for (const id of Object.keys(filterPayload.bizUnits)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        search_results: action.payload
      }
    case success(GET_ALL_SEARCH_RESULTS):
      let $filterPayload = {
        ...action.payload
      }
      for (const list of $filterPayload.clients.data) {
        for (const id of Object.keys($filterPayload.bizUnits)) {
          if (list.id === parseInt(id, 10)) {
            list['children'] = $filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        all_search_results: action.payload
      }
    default:
      return state;
  }
}

export default {
  subscriptionInfo
}


// WEBPACK FOOTER //
// ./src/reducers/subscriptionInfo.js